export default __webpack_public_path__ + "static/media/water.1094c11a.jpg";